exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.ordenar-pedidos-cliente-select[data-v-6d28bbfb] {\n    margin-top: -1.5rem;\n    margin-bottom: 1rem;\n}\n", ""]);
